import React from "react";

const AboutTab = ({ umpire }) => (
  <div className="max-w-2xl mx-auto">
    <h2 className="text-xl font-bold mb-4 text-green-800">Bio Data</h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
      <div className="text-gray-600">Gender</div><div className="font-semibold">{umpire.gender || '—'}</div>
      <div className="text-gray-600">Date of Birth</div><div className="font-semibold">{umpire.dateOfBirth || '—'}</div>
      <div className="text-gray-600">Nationality</div><div className="font-semibold">{umpire.nationality || '—'}</div>
      <div className="text-gray-600">Debut Year</div><div className="font-semibold">{umpire.debutYear || '—'}</div>
      <div className="text-gray-600">Languages Spoken</div><div className="font-semibold">{umpire.languagesSpoken || '—'}</div>
      <div className="text-gray-600">Certifications</div><div className="font-semibold">{umpire.certifications || '—'}</div>
      <div className="text-gray-600">Remarks</div><div className="font-semibold">{umpire.remarks || '—'}</div>
    </div>
  </div>
);

export default AboutTab; 